import { Button, Group, Modal, Radio, SegmentedControl, Stack, Textarea } from '@mantine/core';
import { useState } from 'react';
import {
  DEFAULT_SNOOZE_DAYS,
  SNOOZE_DURATIONS,
  SNOOZE_REASONS,
  type SnoozeReason,
} from 'src/notifications/copy/snoozeReasonCopy';
import { useNotificationActions } from 'src/notifications/hooks/useNotificationActions';

export default function SnoozeModal({
  opened,
  onClose,
  notificationId,
}: {
  opened: boolean;
  onClose: () => void;
  notificationId: string;
}) {
  const { snooze } = useNotificationActions();
  const [reason, setReason] = useState<SnoozeReason>('ALREADY_HANDLED');
  const [reasonText, setReasonText] = useState('');
  const [days, setDays] = useState(DEFAULT_SNOOZE_DAYS);

  const isOther = reason === 'OTHER';
  const confirmDisabled = isOther && reasonText.trim().length === 0;

  const handleConfirm = () => {
    snooze.mutate(
      {
        id: notificationId,
        days: Number(days),
        reason,
        reasonText: isOther ? reasonText.trim() : undefined,
      },
      { onSuccess: onClose },
    );
  };

  return (
    <Modal opened={opened} onClose={onClose} title="Snooze notification" centered>
      <Stack>
        <Radio.Group
          label="Why are you snoozing this?"
          value={reason}
          onChange={value => setReason(value as SnoozeReason)}
        >
          <Stack gap="xs" mt="xs">
            {SNOOZE_REASONS.map(option => (
              <Radio key={option.value} value={option.value} label={option.label} />
            ))}
          </Stack>
        </Radio.Group>

        {isOther && (
          <Textarea
            label="Tell us more"
            value={reasonText}
            onChange={event => setReasonText(event.currentTarget.value)}
            autosize
            minRows={2}
          />
        )}

        <SegmentedControl fullWidth data={SNOOZE_DURATIONS} value={days} onChange={setDays} />

        <Group justify="flex-end" mt="xs">
          <Button variant="default" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirm}
            disabled={confirmDisabled}
            loading={snooze.isPending}
          >
            Confirm
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
